import * as actionTypes from 'ActionTypes';
import axios from 'Axios';
import { api, currentUser } from 'Utils';

export const fetchUserRequest = () => {
	return {
		type: actionTypes.FETCH_USER_REQUEST
	};
};

export const fetchUserFail = () => {
	return {
		type: actionTypes.FETCH_USER_FAIL
	};
};

export const setUser = (user) => {
	return {
		type: actionTypes.SET_USER,
		user
	};
};

export const setToken = (token) => {
	return {
		type: actionTypes.SET_TOKEN,
		token
	};
};

export const fetchUser = () => (dispatch) => {
	dispatch(fetchUserRequest());
	axios
		.post(api.profile)
		.then((res) => {
			const data = res.data;
			dispatch(setUser(data.result));
			currentUser.setUser(data.result)
		})
		.catch(() => {
			dispatch(fetchUserFail());
		});
};
